// extracted by mini-css-extract-plugin
export default {"score":"hoV5I","category":"wl0CA","criterion":"z3mUj","interval":"_2C99S","summary":"zqZPp","training":"woMSf","diff":"sFwuW"};